export type CTIListSettingKey = 'showOnLoad' | 'openOnCall' | 'openOnAnswer';
export type CTISingleSettingKey = 'hideOnAction' | 'logCallsAutomatically';

export type CTISettingsKey = CTIListSettingKey | CTISingleSettingKey;

type ShowOnLoadValue = 'show' | 'hidden' | 'loggedIn';
type OpenOnCallValue = 'off' | 'open_contact';
type OpenOnAnswerValue = 'off' | 'open_ticket';

export type CTISettings = {
    showOnLoad: {
        key: 'showOnLoad';
        label: string;
        value: ShowOnLoadValue;
    };
    openOnCall: {
        key: 'openOnCall';
        label: string;
        value: OpenOnCallValue;
    };
    openOnAnswer: {
        key: 'openOnCall';
        label: string;
        value: OpenOnAnswerValue;
    };
    hideOnAction: {
        key: 'hideOnAction';
        label: string;
        value: boolean;
    };
    logCallsAutomatically: {
        key: 'logCallsAutomatically';
        label: string;
        value: boolean;
    };
};

export const CTI_LIST_SETTINGS_VALUE_LABELS: Record<
    CTIListSettingKey,
    Record<string, string>
> = {
    showOnLoad: {
        show: 'settings.cti.enable.show.on.load',
        hidden: 'settings.cti.disable.show.on.load',
        loggedIn: 'settings.cti.enable.show.on.login',
    },
    openOnCall: {
        off: 'settings.cti.do.not.open.anything',
        open_contact: 'settings.cti.open.contact.on.call',
    },
    openOnAnswer: {
        off: 'settings.cti.do.not.open.anything.on.answer',
        open_ticket: 'settings.cti.open.ticket.on.answer',
    },
};
